module.exports = __webpack_public_path__ + "static/media/notes_project.6d18c124.jpg";